/** True when at least one clinician note contains non-whitespace content. */
export const hasClinicianNoteContent = (notes: string[] | null | undefined): boolean =>
  notes?.some((note) => note.trim().length > 0) ?? false;
